<template>
  <div class="amp-form__wrapper">
    <div v-animation:left.delay class="amp-cube amp-form__cube--left" aria-label="Декор куб слева"></div>
    <div v-animation:right.delay class="amp-cube amp-form__cube--right" aria-label="Декор куб справа"></div>
    <div class="amp-form" v-animation:bottom.delay>
      <p class="amp-form__title">Вход в конференцию</p>
      <p class="amp-form__subtitle">Пожалуйста, введите e-mail, указанный при регистрации</p>
      <label class="amp-form__field">
        <span class="amp-form__field-label">E-mail <span class="amp-form__field-label-mark">*</span></span>
        <input type="text" v-model="email" placeholder="Введите e-mail" class="amp-form__field-input" />
      </label>
      <p v-if="error" class="amp-form__error">
        {{ error }}
      </p>
      <div class="amp-form__btn t-btn _green _big" @click="$emit('event:check-access', email)">Войти</div>
      <router-link
        :to="{ name: 'eventsView', params: { id: 'axoft_maximum_pro_live' }, hash: '#registracia-na-meropriatie' }"
        class="amp-form__btn amp-form__btn--ghost t-link-hover"
      >
        Зарегистрироваться на мероприятие
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "amp-form",
  emits: ["event:check-access"],
  props: {
    error: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      email: null,
    }
  },
}
</script>

<style lang="sass">
.amp-form
  display: flex
  flex-direction: column
  max-width: 424px
  background-color: #FFFFFF
  border-radius: 6px
  padding: 32px

  &__wrapper
    position: relative
    margin-inline: 15px
    display: flex
    width: 100%
    align-items: center
    justify-content: center

  &__title
    font-weight: 600
    font-size: 26px
    line-height: 1.55
    color: #1E253B

  &__subtitle
    font-size: 14px
    line-height: 1.5
    color: #9FA2AC
    margin-top: 16px

  &__field
    margin-top: 32px

    &-label
      display: inline-block
      margin-bottom: 8px
      font-size: 12px
      line-height: 130%
      color: #1E253B

      &-mark
        margin-left: 6px
        color: #D65663

    &-input
      padding: 12px 24px
      background-color: transparent
      border-radius: 6px
      border: 1px solid #E7E7E8
      color: #1E253B
      width: 100%
      font-size: 14px
      line-height: 1.4
      display: block

  &__error
    margin-block: 12px 5px
    font-size: 14px
    line-height: 1.5
    color: #EC7C7C

  &__btn
    margin-top: 16px
    width: 100%
    align-self: center

    &:not(.amp-form__btn--ghost)
      margin-top: 36px

    &--ghost
      margin-top: 16px
      text-align: center
      font-weight: 600

  &__cube--left
    left: -73px
    top: 13%
    background-image: url("/dist/img/ax-max-pro/cube.png")

  &__cube--right
    right: -80px
    top: 52%
    background-image: url("/dist/img/ax-max-pro/cube_2.png")
</style>



// WEBPACK FOOTER //
// src/templates/pages/axoft-maximum-pro/components/amp-form.vue